export const xs = 360;
export const sm = 576;
export const md = 768;
export const lg = 992;
export const xl = 1440;

const breakpoints = { xs, sm, md, lg, xl };
const _respondTo = breakpoint => ` @media (max-width: ${breakpoint}px)`
const _respondMore = breakpoint => ` @media (min-width: ${breakpoint + 1}px)`

const respondTo = {};
const respondMore = {};

Object.keys(breakpoints).forEach(key => {
  respondTo[key] = _respondTo(breakpoints[key]);
})

Object.keys(breakpoints).forEach(key => {
  respondMore[key] = _respondMore(breakpoints[key]);
})

export { respondTo, respondMore };